import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_list` layout match on bare `/account/integrations/$appId/companies`; it renders nothing.
export const Route = createFileRoute('/_app/account/integrations/$appId/companies/_list/')({})
